<script lang="ts">
import { type InjectionKey, type Ref } from 'vue';

export type SensitiveViewMode = 'presentation' | 'cesg';

export const sensitiveValuesModeKey: InjectionKey<
  Readonly<Ref<SensitiveViewMode>>
> = Symbol('sensitiveValuesMode');
</script>

<script lang="ts" setup>
import { PhPresentation } from '@phosphor-icons/vue';

const props = defineProps<{
  mode: SensitiveViewMode;
}>();

const emit = defineEmits<{
  'update:mode': [value: SensitiveViewMode];
}>();
</script>

<template>
  <div class="segment-group">
    <button
      class="segment"
      :class="{ active: props.mode === 'presentation' }"
      @click="emit('update:mode', 'presentation')"
    >
      <span class="segment-icon">
        <PhPresentation :size="16" />
      </span>
      Presentationsläge
    </button>
    <button
      class="segment"
      :class="{ active: props.mode === 'cesg' }"
      @click="emit('update:mode', 'cesg')"
    >
      CESG
    </button>
  </div>
</template>

<style scoped>
.segment-group {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  background: #fff;
  padding: 0.2rem;
  gap: 0.15rem;
}

.segment {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  height: 2rem;
  padding: 0 0.85rem;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s;
}

.segment:hover:not(.active) {
  background: #f3f4f6;
  color: #111827;
}

.segment.active {
  background: #e5e7eb;
  color: #111827;
}

.segment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--primary-color);
}
</style>
